(() => {
  const guidanceSelector = '[data-daylight-activation-guidance]';

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const activationKey = (value) => {
    const normalized = normalize(value);

    if (normalized.includes('professional')) return 'professional';
    if (normalized.includes('remote')) return 'remote';
    return 'manual';
  };

  const updateGuidance = (guidance) => {
    const productInfo = guidance.closest('.product__info-container') || document;
    const selectedActivation = Array.from(productInfo.querySelectorAll('input[type="radio"]:checked')).find(
      (input) => normalize(input.name).startsWith('activation')
    );
    const selectedKey = activationKey(selectedActivation?.value);

    guidance.querySelectorAll('[data-activation-card]').forEach((card) => {
      card.hidden = card.dataset.activationCard !== selectedKey;
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll(guidanceSelector).forEach(updateGuidance);
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
    const productInfo = event.target.closest('.product__info-container');
    productInfo?.querySelectorAll(guidanceSelector).forEach(updateGuidance);
  });

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
